import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  templateUrl: './confirmation-popin.component.html',
})
export class NeqConfirmationPopinComponent implements OnInit {
  message: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {message: string}
  ) {
  }

  ngOnInit() {
    this.message = this.data.message;
  }
}
